module.exports = __webpack_public_path__ + "static/ocrs-calculation-0db091dc9bbf1da915a54ecdaa64eb7d.png";